import { Table } from 'antd'
import { ColumnType } from 'antd/lib/table'

type Props<T> = {
  dataSource: T[],
  columns: ColumnType<T>[]
}

const BudgetTable = <T extends { id: string }>({ columns, dataSource }: Props<T>) => <Table
  columns={columns}
  dataSource={dataSource}
  rowKey={x => x.id}
  size="small"
  pagination={{ hideOnSinglePage: true, pageSize: 100 }}
/>
export default BudgetTable
